import React from 'react'
import {Step, Form, Checkbox, Grid, Modal, Message, Button, Icon, Header, Placeholder, Table, Label, Popup} from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import * as routerActions from '../../actions/RouterActions'
import {GOOGLE_LOCATION_COUNTRY_CODES} from '../../constants/GoogleLocationCountryCodes'

export const StoreEdit = function (props) {

    return (
        <Modal open={true} size="tiny">
            <Modal.Header>Adresse eingeben</Modal.Header>
            <Modal.Description>
                <Step.Group ordered size="mini" attached="bottom">
                    <Step completed>
                    <Step.Content>
                        <Step.Title>Eingabe</Step.Title>
                        <Step.Description>Adresse erfassen</Step.Description>
                    </Step.Content>
                    </Step>

                    <Step active>
                    <Step.Content>
                        <Step.Title>Verifizierung</Step.Title>
                        <Step.Description>über Google Location API</Step.Description>
                    </Step.Content>
                    </Step>

                    <Step >
                    <Step.Content>
                        <Step.Title>Speichern</Step.Title>
                    </Step.Content>
                    </Step>
                </Step.Group>
            </Modal.Description>
            <Modal.Content scrolling style={{
                paddingTop: "20px"
            }}>
                <Form>
                    <Form.Field>
                        <label>Straße und Hausnummer</label>
                        <input placeholder='Musterstraße 15b' />
                    </Form.Field>
                    <Form.Field>
                        <label>PLZ und Ort</label>
                        <input placeholder='12345 Musterhausen' />
                    </Form.Field>
                    <Form.Field>
                        <label>Land</label>
                        <Form.Select upward={true} defaultValue="DE"
                            options={Object.values(Object.keys(GOOGLE_LOCATION_COUNTRY_CODES).map((key) => {
                                return {
                                    key: key, value: key, text: GOOGLE_LOCATION_COUNTRY_CODES[key]
                                }
                            }))}
                            placeholder="Land"
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Grid columns={2}>
                    <Grid.Column textAlign="left">
                        <Button onClick={() => dispatch(routerActions.push('storelocator/stores/' + lotteryId + (filter?('/' + filter):'')))}>
                            Abbruch
                        </Button>
                    </Grid.Column>
                    <Grid.Column>
                        <Button content="Adresse verifizieren" icon='right arrow' labelPosition='right' primary onClick={() => dispatch(routerActions.push('storelocator/stores/' + lotteryId + (filter?('/' + filter):'')))} />
                    </Grid.Column>
                </Grid>
            </Modal.Actions>
        </Modal>
    )
}